import * as React from "react";

const YoutubeIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="42"
        fill="none"
        viewBox="0 0 50 50"
    >
        <rect width="50" height="50" fill="#36387D" rx="8"></rect>
        <path
            fill="#fff"
            d="M40.298 17.336C41 19.793 41 25.058 41 25.058s0 5.207-.702 7.722c-.351 1.404-1.462 2.457-2.808 2.808-2.516.644-12.46.644-12.46.644s-10.004 0-12.52-.644c-1.345-.35-2.457-1.404-2.808-2.808C9 30.265 9 25.058 9 25.058s0-5.265.702-7.722c.351-1.404 1.463-2.515 2.808-2.866 2.516-.702 12.52-.702 12.52-.702s9.944 0 12.46.702c1.346.35 2.457 1.462 2.808 2.866m-18.545 12.46 8.307-4.738-8.307-4.738z"
        ></path>
    </svg>
);

export default YoutubeIcon;
